import {
  Ecolums_h,
  Indtech_h,
  loyal_h,
  Suppriya_h,
  Loha_h,
  Layamr_h,
  IndtechApp_h,
  LohaApp_h,
  Ipasbook_h,
  IpasOman_h,
  Ecolums_web1,
  Loha_web2,
  Layamr_web2,
  Loyal_web1,
  Supriya_web1,
  Loha_fms1,
  Loha_fms2,
  Indtech_fms1,
  Indtech_fms2,
  Indtech_fms3,
  IpasOman_web1,
  Ipas_web1,
  Ipas_web2,
  Layamr_web1,
  Loha_web1,
  Zeston_app1,
  Zeston_web_dashboard1,
  Zeston_web_dashboard2,
  Zeston_web_dashboard3,
  Zeston_web_dashboard4,
  Zeston_web1,
  zeston_app,
  Layamr_web3,
  Layamr_web4,
  Loha_fms_h,
  Loha_fms3,
  Deals2Home_h,
  Deals2Home,
  Deals2Home1,
  Deals2Home2,
} from './img';

// loha
import Loha_cover_home from './img/caseStudy/Loha/loha-cover-mob-.jpg';
import LohaMockupVideo from 'assets/img/caseStudy/Loha/app-mock-up-video.mp4';
import LohaImage1 from './img/caseStudy/Loha/Osperb-grid-erp-laptop-image-.jpg';
import LohaImage2 from './img/caseStudy/Loha/osperb-grid-software-laptop-image-.jpg';
import LohaImage3 from './img/caseStudy/Loha/osperb-grid-field-app-dashboard-web-.jpg';
import LohaImage4 from './img/caseStudy/Loha/osperb-grid-field-dashboard-.jpg';
import LohaImage5 from './img/caseStudy/Loha/Osperb-grid-workorder-screen-shot-.jpg';

// focus 
import Focus_video_home from './img/caseStudy/Focus/focus-cover.mp4';
import FocusImage1 from './img/caseStudy/Focus/Osperb-grid-for-focus-inspection-web.jpg';
import FocusImage2 from './img/caseStudy/Focus/focus-motors-web-all-mocup.jpg';
import FocusImage3 from './img/caseStudy/Focus/osperb-grid-for-focus-image-.jpg';

// buildex
import BuildexImage1 from './img/caseStudy/buildex/Buildex-dashboard-.jpg';
import BuildexImage2 from './img/caseStudy/buildex/buildex-dashboard-by-osperb-.jpg';
import BuildexImage3 from './img/caseStudy/buildex/orders-duldex.jpg';
import buildexCard from 'assets/img/caseStudy/buildex/alkhali-buildex-card.mp4';


export const colors = {
  navColor: '#333',
  white: '#fff',
  black: '#000',
  navBrandColor: '#1881bb',
  osperb: '#1881bb',
};

// 1881bb
//first 3 object for homepage
//use "All", "Web","Mobile", "ERP" for fiilter option you can add more in TouchBar.js file

export const WorkData = [
  {
    id: 'loha',
    //images
    clientName: 'LOHA GRID',
    homeImage: LohaMockupVideo,
    TouchBarImg: Loha_cover_home,
    images: [LohaImage1, LohaImage2, LohaImage3, LohaImage4, LohaImage5],
    isStudyAvailable: true,
    filter: ['ERP', 'Web', 'Mobile'],
    //deatils
    clientNameFull: 'LOHA Steel Doors & Windows',
    location: 'South India',
    category: 'Factory Management System',
    homePageContent: `How we fixed LOHA’s steel window quotation headache and systemised production scheduling and factory operations`,
    footerContent: `LOHA is a leading steel doors and windows manufacturer in South India, handling highly customized steel window orders. Their biggest bottleneck was generating quotations for custom-sized windows, as staff depended on owners to estimate prices accurately. Osperb built LOHA GRID, a complete factory management system containing a product customization module, an automated cost engine, and production scheduling that drives end-to-end factory workflow—eliminating owner dependency and turning a reactive environment into a predictable workflow.`,
    specsContent: [
      'Product Customisation + Quote Generation',
      'Automated Production Scheduling',
      'End-to-End Factory Workflow Management',
      'Field Sales Mobile App + GPS Monitoring',
      'Real-Time Field Activity Dashboard',
      'Stage-by-Stage Operational Visibility',
      'Multi-Level Production Tracking',
      'Revenue Analysis and Dynamic Reporting',
      'etc.',
    ],
  },
  {
    id: 'buildex',
    //images
    clientName: 'Buildex Stores',
    homeImage: buildexCard,
    TouchBarImg: BuildexImage1,
    images: [BuildexImage1, BuildexImage2, BuildexImage3],
    isStudyAvailable: true,
    filter: ['Web', 'B2C e-commerce'],
    //deatils
    clientNameFull: 'Al Khalili United Enterprises LLC',
    location: 'Oman',
    category: 'B2C e-commerce',
    homePageContent: `How we took a 26+ store retail brand online in Oman by building an enterprise e-commerce ecosystem for Buildex Stores `,
    footerContent: `Buildex Stores is a trusted retail brand in Oman under the Al Khalili Group, with a strong physical presence across the country. They needed more than a normal e-commerce website—because their large catalog, regional tax requirements, bilingual (Arabic/English) customer journeys, and multiple fulfillment models demanded an enterprise-grade system. Osperb built a custom enterprise e-commerce ecosystem with an optimized customer storefront and a powerful admin and sub-admin control layer. The platform supports Arabic and English shopping experiences, OMR pricing, VAT-ready tax calculation for both items and shipping, loyalty tiers, and special purchase flows like preorder and enquiry. Operations stay scalable through bulk uploads, export-ready reporting, role-based permissions, and flexible fulfillment workflows including delivery and pickup options.`,
    specsContent: [
      'Arabic & English journeys with region-specific UX',
      'OMR pricing with detailed tax breakdowns (item + shipping logic)',
      'Large catalogs with complex variants, images, and IDs',
      'Special product journeys: Preorder and Enquiry-based items',
      'Tier-based loyalty points + redemption rules',
      'Multiple fulfillment models: Home Delivery, Click & Collect, Store Pickup',
      'Bulk operations, reporting, exports, and operational automation',
      'Full admin control over UI, content, offers, and workflows',
      'Bank Muscat payment gateway integration',
      'SAP ID Mapping (ERP-Ready Foundation)',
      'etc.',
    ],
  },
  {
    id: 'focus',
    //images
    homeImage: Focus_video_home,
    TouchBarImg: FocusImage1,
    images: [FocusImage1, FocusImage2, FocusImage3],
    isStudyAvailable: true,
    filter: ['Web', 'Mobile', 'ERP'],
    //deatils

    clientName: 'Focus Motors',
    clientNameFull: 'Focus Motors',
    location: 'Oman',
    category: 'Tech Ecosystem',
    homePageContent: `How we helped Focus Motors achieve 5× revenue by transforming a used-car showroom into a connected Tech Ecosystem `,
    footerContent: `Leading pre-owned car business Focus Motors needed faster lead handling, better follow-ups, and more customer trust to grow. We transformed their operations into a connected Tech Ecosystem delivered phase-by-phase. The impact was immediate: lead response dropped from ~48 hours to minutes, follow-ups became trackable alerts, inspections scaled 5×, and two branches with 32+ staff began operating with consistent processes and real-time visibility - supporting Focus Motors’ 5× revenue growth.`,
    specsContent: [
      'Virtual Showroom (Website) for structured lead generation',
      'CRM + Inventory + Operations CMS for centralized execution',
      'Sales Mobile App for real-time and field-friendly follow-ups',
      'Focus Inspection system to make vehicle trust verifiable',
      'Multi-Branch Management to standardize operations',
      'Automated WhatsApp lead routing',
      'Real-time staff execution and notifications',
      'Cloud report delivery and QR verification',
      'etc.',
    ],
  },

  {
    id: '4',
    //images
    homeImage: Loha_h,
    TouchBarImg: Loha_h,
    images: [Loha_h, Loha_web2, Loha_web1],
    filter: ['ERP', 'Web'],
    //deatils
    clientName: 'Loha Web',
    location: 'South India',

    category: 'Brand Profile and Enquiry Acquisition',
    footerContent: ` Brands needed a shoutout to get highlighted in the modern electronic world.This project was a customized website that profiles the company 
                     and its products through media contents.The web app represents the digital version of catelogue and showcases all the specifications related with the items.
                     Enquiry acquisition and management is an importmant segment to improve the customer creation and retention.We have implemented dedicated dashboard for dealing it seamlessly.
                   `,
    specsContent: [
      'Dynamic Products listing',
      'Detailed Featuring',
      'WhatsApp Chat integration',
      'Common and Individual product based Enquiry',
      'Proposal request form',
      'Enquiry Management dashboard',
      'Enquiry reports',
      'etc.',
    ],
  },

  {
    id: '1',
    //images
    homeImage: zeston_app,
    TouchBarImg: zeston_app,
    images: [zeston_app, Zeston_app1],
    filter: ['Mobile', 'Web'],
    //details
    clientName: 'Zeston App',
    location: 'Kerala ',
    category: 'Multi-Store Ecommerce Mobile Application',
    footerContent: ` Zeston is a well fledged brand across kerala focussed on wholesale home decor and accessories market.
                     Our challenge was to position their brand and customized products into people's minds and deliver their needs fast.
                     Thus the upgradation to an ecommerce platform was the finest solution.Our teamwork and deication paved the path to its fulfillment, and it happened.
                   `,
    specsContent: [
      'Inventory management',
      'Multi-varient product listing',
      'Seperate Base-product and dealer-product listing',
      'Dealer, shop creation and management',
      'Location based store selection for user',
      'Multi-store order management',
      'Order status allocation and fulfillment options',
      'Revenue analysis and other reports',
      'Notifications for users and dealers',
      'etc.',
    ],
  },
  {
    id: '3',
    //images
    homeImage: Layamr_h,
    TouchBarImg: Layamr_h,
    images: [Layamr_h, Layamr_web2, Layamr_web1, Layamr_web3, Layamr_web4],
    filter: ['Web'],
    //details
    clientName: 'Layamr',
    location: 'UAE',
    category: 'Ecommerce Web Application',
    footerContent: ` Textiles and Fashion segment needs more customised products nowadays to reach more customers.Layamr is a premium brand for scarfs and underscarfs in Dubai, UAE.
                     They needed a platform to reach their customers digitally and give them products of their choice.We delivered a customized ecommerce platform for layamr with
                     maximum product highlights and video display. 
                   `,
    specsContent: [
      'Multi priced products',
      'Inventory management with stock',
      'Different varient listing with models',
      'video attachment for every product',
      'Customized admin dashboard ',
      'Online payment gateway with all types of card integrations',
      'Smooth checkout and ordering procedures',
      'Order listing and fulfillment status monitoring',
      'Email notifications for users',
      'Guest option for instant checkout',
      'etc.',
    ],
  },

  {
    id: '5',
    //images
    homeImage: Zeston_web1,
    TouchBarImg: Zeston_web1,
    images: [
      Zeston_web1,
      Zeston_web_dashboard1,
      Zeston_web_dashboard2,
      Zeston_web_dashboard3,
      Zeston_web_dashboard4,
    ],
    filter: ['Mobile', 'Web'],
    //details
    clientName: 'Zeston Web',
    location: 'Kerala',
    category: 'Multi-Store Ecommerce Web Application',
    footerContent: ` Zeston is a well fledged brand across kerala focussed on wholesale home decor and accessories market.
                     Our challenge was to position their brand and customized products into people's minds and deliver their needs fast.
                     Thus the upgradation to an ecommerce platform was the finest solution.Our teamwork and deication paved the path to its fulfillment, and it happened.
                   `,
    specsContent: [
      'Inventory management',
      'Multi-varient product listing',
      'Seperate Base-product and dealer-product listing',
      'Dealer, shop creation and management',
      'Location based store selection for user',
      'Multi-store order management',
      'Order status allocation and fulfillment options',
      'Revenue analysis and other reports',
      'Notifications for users and dealers',
      'etc.',
    ],
  },
  {
    id: '6',
    //images
    homeImage: LohaApp_h,
    TouchBarImg: LohaApp_h,
    images: [LohaApp_h],
    filter: ['ERP', 'Web'],
    //deatils
    clientName: 'Loha App',
    location: 'South India',

    category: 'Factory Management System - Mobile App',
    footerContent: ` Factories are hectic with work and workers.Managing them both makes the job tidious.Loha steels is a leading steel doors and windows manufacturing company in kerala.
                     They approached us for making their managing easier and efficient.We provided them with Enterprise Resource Planning Application, inorder to list, maintain, allocate, and manage 
                     all their work segments in a single window.Thus they are more performance oriented and efficient now.
                   `,
    specsContent: [
      'Summary of all processes',
      'Inventory analysis',
      'Work order and job data list',
      'Staff, labour and other resource list',
      'work order monitoring and notifications',
      'Factory monitoring dashboard',
      'Revenue analysis and other reports',
      'etc.',
    ],
  },

  {
    id: '7',
    //images
    homeImage: Ecolums_h,
    TouchBarImg: Ecolums_h,
    images: [Ecolums_h, Ecolums_web1],
    filter: ['Web', 'ERP'],
    //details
    clientName: 'Ecolums',
    location: 'India',

    category: 'Investment/Share Management Application',
    footerContent: ` Eco Lums Marketing LLP is an enthusiastic venture to promote and support eco friendly startups and projects.Investment and other cash flow management systems
                    need high end computational methodologies and analysis.We launched an efficient and scalable cash flow integration application with dashboard for both investors to 
                    know about their share values and all the data regarding company they have invested and the profit they received.Management team have the functionality operate the dealings,
  value creation procedures and all other maintaining of share holders in a single window`,
  },
  {
    id: '8',
    //images
    homeImage: IndtechApp_h,
    TouchBarImg: IndtechApp_h,
    images: [IndtechApp_h],
    filter: ['ERP'],
    //details
    clientName: 'Indtech App',
    location: 'India',

    category: 'Production Management System - Mobile App',
    footerContent: `Factories are hectic with work and workers.Managing them both makes the job tidious.Indtech health care is a leading hospital steel furniture manufacturing company in kerala.
                    They approached us for making their managing easier and efficient.We provided them with Enterprise Resource Planning Application, inorder to list, maintain, allocate, and manage 
                    all their work and manufacturing segments in a single window.Thus they are more performance oriented and efficient now.`,
    // specsContent: []
  },
  {
    id: 'Indtech_osperb',
    //images
    homeImage: Indtech_h,
    TouchBarImg: Indtech_h,
    images: [Indtech_h],
    filter: ['ERP'],
    //details
    clientName: 'Indtech',
    location: 'India',

    category: 'Brand Profile',
    footerContent: ` Brands needed a shoutout to get highlighted in the modern electronic world.This project was a customized website that profiles the company 
                     and its products through media contents.The web app represents the digital version of catelogue and showcases all the specifications related with the items.
                   `,
    specsContent: [
      'Dynamic Products listing',
      'Detailed Featuring',
      'WhatsApp Chat integration',
      'etc.',
    ],
  },
  {
    id: 'Indtech_Fms_osperb',
    //images
    homeImage: Indtech_fms1,
    TouchBarImg: Indtech_fms1,
    images: [Indtech_fms2, Indtech_fms3, Indtech_fms1],
    filter: ['ERP'],
    //details
    location: 'India',

    clientName: 'Indtech Fms',
    category: 'Production Management System',
    footerContent: `Factories are hectic with work and workers.Managing them both makes the job tidious.Indtech health care is a leading hospital steel furniture manufacturing company in kerala.
                    They approached us for making their managing easier and efficient.We provided them with Enterprise Resource Planning Application, inorder to list, maintain, allocate, and manage 
                    all their work and manufacturing segments in a single window.Thus they are more performance oriented and efficient now.`,
    specsContent: [
      'Raw materials listing',
      'Inventory management',
      'Work order and job creation',
      'Dealer order listing and approval with quotation',
      'Multi-level production management',
      'Quality control and quality check options',
      'Staff, labour and other resource management',
      'Factory monitoring dashboard',
      'Revenue analysis and other reports',
      'etc.',
    ],
  },

  // {
  //   id: "finserv_osperb",
  //   //images
  //   homeImage: "",
  //   TouchBarImg: "",
  //   images: [Indtech1],
  //   filter: ["ERP"],
  //   //details
  //   clientName: " MXT Ideal finserv Web",
  //   category: "carde details",
  //   footerContent: "descriotions",
  // },
  {
    id: 'Ipas_osperb',
    //images
    homeImage: Ipasbook_h,
    TouchBarImg: Ipasbook_h,
    images: [Ipas_web1, Ipasbook_h, Ipas_web2],
    filter: ['Web'],
    //details
    clientName: 'IPAS',
    location: 'GCC and India',

    category: 'Acounting Application Profile',
    footerContent: ` Brands needed a shoutout to get highlighted in the modern electronic world.This project was a customized website that profiles the company 
                    and its product 'IPAS BOOK' through media contents.The web app represents the digital version of catelogue and showcases all the specifications related with the app.
                    Dowload options for the product in all devices is also listed in it.
                  `,
  },
  {
    id: 'Loyal_osperb',
    //images
    homeImage: loyal_h,
    TouchBarImg: loyal_h,
    images: [Loyal_web1, loyal_h],
    filter: ['Web'],
    //details
    clientName: 'Loyal',
    location: 'Dubai, UAE',

    category: 'Service Profile',
    footerContent: ` Brands needed a shoutout to get highlighted in the modern electronic world.This project was a customized website that profiles the company 
                    and its services through media contents.The web app represents the digital version of catelogue and showcases all the specifications related with the service.
                  `,
  },

  {
    id: 'ipasoman_osperb',
    //images
    homeImage: IpasOman_h,
    TouchBarImg: IpasOman_h,
    images: [IpasOman_web1, IpasOman_h],
    filter: ['Web'],
    //details
    clientName: 'Ipas Oman',
    location: 'Oman',

    category: 'Service Profile',
    footerContent: ` Brands needed a shoutout to get highlighted in the modern electronic world.This project was a customized website that profiles the company 
                    and its services through media contents.The web app represents the digital version of catelogue and showcases all the specifications related with the service.
                  `,
  },

  {
    id: 'Supriya_osperb',
    //images
    homeImage: Suppriya_h,
    TouchBarImg: Suppriya_h,
    images: [Supriya_web1, Suppriya_h],
    filter: ['Web'],
    //details
    clientName: 'Supriya',
    location: 'Kerala',

    category: 'Product Detailing Website',
    footerContent: `Supriya mattresses is serving the community offering healthy sleep for a healthy life.Our base factory is located at Kondotty in Malappuram.
                    Brands needed a shoutout to get highlighted in the modern electronic world.This project was a customized website that profiles the company 
                    and its products through media contents.The web app represents the digital version of catelogue and showcases all the specifications related with the items.
                   `,
  },
  {
    id: 'Deals2Home_osperb',
    //images
    homeImage: Deals2Home_h,
    TouchBarImg: Deals2Home_h,
    images: [Deals2Home_h, Deals2Home, Deals2Home1, Deals2Home2],
    filter: ['Mobile', 'Web', 'ERP'],
    //details
    clientName: 'Deals2Home',
    location: 'Kerala',

    category: 'Dedicated admin dashboard and mobile app',
    footerContent: `Deal 2 Home is a multi - store ecommerce platform consisting of a user web and app, admin app, and dashboard.
     It features a dynamic homepage, category / sub - category listings, product collections, and multiple banner options.
     Users can select their nearest available store, and admins receive order notifications.Push notifications update users on their order status.
                   `,
    specsContent: [
      'Dynamic homepage for seasonal updates.',
      '	Category and subcategory-based listing with multi-category options.',
      'Product collections listing for special offers.',
      'Multiple banner options.',
      'User location based store  selection and default store at unavailable areas.',
      'Order management and product listing through admin app.',
      '	New order notification to admin app with alarm.',
      'Push notification for order updates.',
      'etc.',
    ],
  },
];
